export default function localNumberWithZero(value) {
  if (!value) {
    return "0";
  }

  if (!isNaN(value)) {
    return value.toLocaleString();
  } else {
    return "0";
  }
}
